<template>
    <multiselect
        v-model="selectedLock"
        :options="locks"
        :custom-label="lockVisibleName"
        @select="lockSelected"
        track-by="name"
        placeholder="Any Lock"
        :searchable="true"
        @search-change="asyncFind"
        :loading="isLoading"
        :internal-search="false"
        :allow-empty="true"
    >
        <template v-slot:noOptions>Enter 3+ characters to search</template>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Locks from "../Services/Locks";

    export default {
        name: "LockSelectComponent",
        components: {
            Multiselect
        },
        props: ['centreId'],
        data: function() {
            return {
                lockName : '',
                selectedLock: {id: '', name: 'All locks'},
                locks: [],
                isLoading: false,
                disableLock: {id: '', name: 'All locks'},
            }
        },
        methods: {
            asyncFind (query) {
                let self = this;
                if (query.length < 3) {
                    return;
                }
                this.isLoading = true;
                Locks.fetchLocks(this.centreId, query).then(function (locks) {
                    self.locks = locks;
                    self.locks.push(self.disableLock);
                    self.isLoading = false;
                })
            },

            lockVisibleName: function(lock) {
                return lock.name;
            },

            lockSelected: function (lock) {
                this.selectedLock = lock;
                this.$emit('update:lock', lock);
            }
        }
    }
</script>

<style scoped>

</style>
